import { createSlice } from "@reduxjs/toolkit";

const attributesSlice = createSlice({
	name: "attributes",
	initialState: {
		loadingAttributes: false,
		error: null,
	},
	reducers: {
		getAttributes(state, action) {
			return { ...state, loadingAttributes: true };
		},
		setAttributes(state, action) {
			const attributesData = action.payload;
			return {
				...state,
				loadingAttributes: false,
				...attributesData,
			};
		},
		getAttributesFail(state, action) {
			const error = action.payload;
			return { ...state, error: { ...error }, loadingAttributes: false };
		},
	},
});

export const { getAttributes, setAttributes, getAttributesFail } =
	attributesSlice.actions;

export default attributesSlice.reducer;
